import { IMAGES_AI_API } from '../config/config';

const ImagenesAIService = {
  generate: (params, onProgress) => generate(params, onProgress),
};

const generate = async (params, onProgress) => {
  const config = onProgress
    ? {
        onUploadProgress: (evt) => {
          if (evt.total) {
            const percent = Math.round((evt.loaded * 100) / evt.total);
            onProgress(percent);
          }
        },
      }
    : {};
  const response = await IMAGES_AI_API.post('/generate', params, config);
  return response.data;
};

export default ImagenesAIService;
